export const rolesToNumbers = {
    Municipality: 1,
    Director: 2,
    Admin: 3,
    SuperAdmin: 4
};

export const rolesNames = [
    "Municipality",
    "Director",
    "Admin",
    "SuperAdmin",
];

export const rolesToBulgarian = {
    Municipality: "Общински служител",
    Director: "Директор",
    Admin: "Администратор",
    SuperAdmin: "Супер администратор",
}

export const sizeOptions = [
    { label: 'Малък', value: 'small' },
    { label: 'Нормален', value: 'normal' },
    { label: 'Голям', value: 'large' }
];


export const roles = [
    { name: "Общински служител", code: 1 },
    { name: "Директор", code: 2 },
    { name: "Администратор", code: 3 },
    { name: "Супер администратор", code: 4 },
]